// =============================================
// Device Fingerprint - זיהוי מכשיר ייחודי
// משמש לזיהוי מכשירים חדשים ודרישת OTP מחדש
// =============================================

const STORAGE_KEY = 'kipikid-device-id';

/**
 * יצירת fingerprint ייחודי למכשיר.
 * משלב מאפיינים קבועים של הדפדפן/מכשיר ל-hash קבוע.
 */
async function generateFingerprint(): Promise<string> {
  const components: string[] = [];

  // מאפייני דפדפן בסיסיים
  components.push(navigator.userAgent);
  components.push(navigator.language);
  components.push(String(navigator.hardwareConcurrency || 0));
  components.push(String(screen.width) + 'x' + String(screen.height));
  components.push(String(screen.colorDepth));
  components.push(Intl.DateTimeFormat().resolvedOptions().timeZone);

  // Canvas fingerprint (קבוע לאותו מכשיר/דפדפן)
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (ctx) {
      canvas.width = 200;
      canvas.height = 50;
      ctx.textBaseline = 'top';
      ctx.font = '14px Arial';
      ctx.fillStyle = '#f60';
      ctx.fillRect(100, 1, 62, 20);
      ctx.fillStyle = '#069';
      ctx.fillText('KipiKid', 2, 15);
      components.push(canvas.toDataURL().slice(-50));
    }
  } catch {
    // Canvas לא זמין
  }

  // יצירת hash
  const raw = components.join('|');
  const encoder = new TextEncoder();
  const data = encoder.encode(raw);

  if (crypto.subtle) {
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('').slice(0, 32);
  }

  // Fallback: hash פשוט אם crypto.subtle לא זמין
  let hash = 0;
  for (let i = 0; i < raw.length; i++) {
    const char = raw.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(16).padStart(16, '0');
}

/**
 * קבלת Device Fingerprint - משתמש ב-cache ב-localStorage
 */
export async function getDeviceFingerprint(): Promise<string> {
  // בדיקה אם כבר יש fingerprint שמור
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    return stored;
  }

  // יצירת fingerprint חדש ושמירה
  const fingerprint = await generateFingerprint();
  localStorage.setItem(STORAGE_KEY, fingerprint);
  return fingerprint;
}
